<template>
  <div>
    <div class="page-content">
      <div class="card w-75 mb-5" style="margin: 50px auto">
        <div>
          <div>
            <div id="orderList" class="m-3 p-2 rounded">
              <div v-if="currentStep === 1">
                <div class="text-center m-">
                  <h5 class="text-warning" v-if="page_no === 1">Operator ID</h5>
                </div>
                <div class="col-md-8 m-auto mt-5 text-start">
                  <label
                    for="travels_name"
                    class="form-label text-start fw-bold"
                    >Enter Operator Id<span style="color: red">*</span></label
                  >
                  <input
                    type="text"
                    style="height: 50px"
                    v-model="operatorId"
                    @input="v$.operatorId.$touch()"
                    class="form-control mt-2"
                    placeholder="Enter Operator Id"
                  />
                  <div class="error-message">
                    <span v-if="v$.operatorId.$error">
                      {{ v$.operatorId.$errors[0]?.$message }}
                    </span>
                  </div>
                  <button
                    :disabled="!v$.operatorId.$dirty || v$.operatorId.$invalid"
                    @click="checkOperator"
                    style="
                      height: 45px;
                      width: 100%;
                      background-color: #eab308;
                      border: none;
                    "
                    type="button"
                    class="text-white mt-5 mb-5"
                    :class="[
                      'btn',
                      {
                        'btn-soft-warning':
                          !loading ||
                          v$.operatorId.$dirty ||
                          v$.operatorId.$invalid,
                        'btn-grey':
                          !v$.operatorId.$dirty ||
                          v$.operatorId.$invalid ||
                          loading,
                      },
                    ]"
                  >
                    <div
                      v-if="loading"
                      style="height: 30px"
                      class="spinner-border text-white"
                      role="status"
                    ></div>
                    <div v-else class="text-white">Verify & Continue</div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ToastNotification ref="toast" />
    </div>
  </div>
</template>

<script>
import { required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import { getOperatorById } from "@/apis/operator";
import ToastNotification from "@/components/dialog/ToastNotification.vue";

export default {
  name: "addBuses",
  components: {
    ToastNotification,
  },

  data() {
    return {
      loading: false,

      page_no: 1,
      currentStep: 1,

      operatorId: "",
      routeId: null,

      v$: null,
    };
  },

  methods: {
    startLoading() {
      this.loading = true;
    },

    stopLoading() {
      this.loading = false;
    },

    async checkOperator() {
      this.startLoading();
      const response = await getOperatorById(this.operatorId.trim());
      if (response.success) {
        localStorage.setItem("user_edit_data", JSON.stringify(response.data));
        this.$refs.toast.showToast("Operator found ", "success");
        setTimeout(() => {
          this.$router.push({
            path: `/add_operator/${response.data.phone_number}`,
          });
        }, 2000);
      } else {
        this.operatorId = "";
        this.$refs.toast.showToast("Operator Not Found", "error");
      }
      this.stopLoading();
    },
  },

  validations: {
    operatorId: { required },
  },

  created() {
    this.v$ = useVuelidate(this.$options.validations, this);
  },
};
</script>

<style scoped>
.btn-grey {
  background-color: #d6d6d6 !important;
  color: #a5a5a5 !important;
  border-color: #d6d6d6 !important;
  cursor: not-allowed;
}
</style>
